












/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import GoBackWithCloseTabMixin from '@/common/mixins/go-back-with-close-tab';
import AddEditAreaList from './components/add-edit-area-list.vue';
import { AREA_LIST } from '../router-names';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: { AddEditAreaList }
})
export default class AreaListCreate extends Mixins(GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/area-list/';
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  headTitle = '区域新增'; // 标题
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '区域信息',
        location: {
          name: AREA_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: AREA_LIST
    });
  }
}
